import React, { FC } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';
import setQaAttribute from '../../../helpers/setQaAttribute';

interface IProps {
  value: string;
  isDisabled?: boolean;
  isOpened?: boolean;
  qaId?: string;
}

const Select: FC<IProps> = ({ value, isDisabled, isOpened, qaId }) => (
  <button
    className={classNames(css.select, {
      [css.isDisabled]: isDisabled,
    })}
    disabled={isDisabled}
    {...(qaId ? { ...setQaAttribute(qaId) } : {})}
  >
    <span className={css.select__content}>
      <span className={css.select__value}>{value}</span>
      <span
        className={classNames(css.select__arrow, {
          [css[`select__arrow_position_up`]]: isOpened,
        })}
      >
        <Icon id="24--select-arrow" />
      </span>
    </span>
  </button>
);

export default Select;
